"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.domainSettings = exports.settings = void 0;
exports.settings = {
    returnUrlParam: 'returnUrl',
    domains: {
        spaceship: {
            hostName: 'www.spaceship.com',
            loginPath: '/auth/',
            brandId: 'spaceship',
        },
        spaceshipIs: {
            hostName: 'www.spaceship.is',
            loginPath: '/auth/',
            brandId: 'spaceship',
        },
        brandstore: {
            hostName: 'www.brandstore.com',
            loginPath: '/auth/',
            brandId: 'brandstore',
        },
    },
};
exports.domainSettings = Object.freeze(Object.keys(exports.settings.domains).map((key) => exports.settings.domains[key]));
